import baseAPI from '@/http'

const router = 'api/cargofuncao'

export const cargosFuncoes = {
  create: (cargos) => baseAPI.post(router + '/cadastrar-cargos-funcoes', cargos),
  update: (cargos) => baseAPI.put(router + '/atualizar-cargo-funcao', cargos),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
